import { Field as FieldPrimitive } from "@base-ui/react/field";
import * as React from "react";

import { FieldRootContext } from "@beweegbaas/ui/lib/field-context";
import { focusStyles } from "@beweegbaas/ui/lib/focus-styles";
import { cn } from "@beweegbaas/ui/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  const inField = React.useContext(FieldRootContext);
  const textarea = (
    <textarea
      data-slot="textarea"
      className={cn(
        `border-input dark:bg-input/30 aria-invalid:ring-destructive/20
        dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive
        dark:aria-invalid:border-destructive/50
        placeholder:text-muted-foreground flex field-sizing-content min-h-16
        w-full rounded-md border bg-transparent px-2.5 py-2 text-base shadow-xs
        disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-[3px]
        md:text-sm`,
        focusStyles,
        className,
      )}
      {...props}
    />
  );

  // Inside a Field, register as its control so label/description/error
  // association and validity state come from Base UI.
  if (inField) {
    return <FieldPrimitive.Control render={textarea} />;
  }
  return textarea;
}

export { Textarea };
